<template>
  <div class="Container">
    <h2 class="ViewHeading">O-1 Actions</h2>
    <!-- <b-container class="OverallContainer"> -->
      <!-- <b-modal
        ref="termsModal"
        id="termsModal"
        hide-header
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        title="Terms and Conditions"
        content-class="Modal"
      >
        <div>
          <h3>Terms and Conditions</h3>
          <p>
            The purpose of the Clarence device is to provide periodic data to
            the user, detailing the quality of the water tested by the unit.
          </p>

          <p>
            By clicking agree you hereby confirm that you accept the License
            Agreement <a href="T&C"> (detailed here) </a> and additionally grant
            permission to Angel Guard Limited to process the data from the
            device detailed above, in order to allow the device to function
            effectively."
          </p>

          <br />

          <div id="cookieButton">
            <button class="button" id="button" v-on:click="CommissionDevice()">
              Accept
            </button>
            <button class="button" id="button" v-on:click="DeclineTerms()">
              Decline
            </button>
          </div>
        </div>
      </b-modal> -->

      <!--      MODAL END MODAL END MODAL END MODAL END MODAL END MODAL END MODAL END MODAL END MODAL END MODAL END            -->
    <!-- </b-container> -->

    <b-card>
      <b-table
        sticky-header
        id="O1Table"
        :items="o1items"
        :fields="fields"
        no-border-collapse
        hover
        show-empty
        empty-text="You currently dont have any Assets of this type"
        responsive
        small
      >
        <template v-slot:cell(Action)="{ item }">
          <b-button
            variant="outline-info"
            size="sm"
            v-on:click="getDataToAction(item, 'Clarence-O1')"
          >
            Action
          </b-button>
        </template>
        <template v-slot:cell(ID)="{ item }">
          {{ getNewName(item.ID, "O1") }}
        </template>
      </b-table>
      <hr />
        </b-card>
        <b-modal
          id="ProbeToRemoveModal"
          ref="ProbeToRemoveModal"
          title="Select Probes to Remove"
          hide-footer
        >
          <b-card>
            <template #header>
              Select Probes to Remove
            </template>
            <b-row v-if="this.dataToDisplay[0].Probe1Show == 'TRUE'">
              <b-col cols="3"> Probe 1 </b-col>
              <b-col cols="3"> {{ this.dataToDisplay[0].Probe1Feed }} </b-col>
              <b-col cols="4" >
                {{ this.dataToDisplay[0].Probe1Position }}
              </b-col>
              <b-col cols="1">
                <b-form-checkbox
                  id="checkbox-1"
                  v-model="Probe1Check"
                  name="checkbox-1"
                  value="TRUE"
                  unchecked-value="FALSE"
                >
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row v-if="this.dataToDisplay[0].Probe2Show == 'TRUE'">
              <b-col cols="3"> Probe 2 </b-col>
              <b-col cols="3"> {{ this.dataToDisplay[0].Probe2Feed }} </b-col>
              <b-col cols="4" >
                {{ this.dataToDisplay[0].Probe2Position }}
              </b-col>
              <b-col cols="1" >
                <b-form-checkbox
                  id="checkbox-2"
                  v-model="Probe2Check"
                  name="checkbox-2"
                  value="TRUE"
                  unchecked-value="FALSE"
                >
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row  v-if="this.dataToDisplay[0].Probe3Show == 'TRUE'">
              <b-col cols="3"> Probe 3 </b-col>
              <b-col cols="3"> {{ this.dataToDisplay[0].Probe3Feed }} </b-col>
              <b-col cols="4">
                {{ this.dataToDisplay[0].Probe3Position }}
              </b-col>
              <b-col cols="1">
                <b-form-checkbox
                  id="checkbox-3"
                  v-model="Probe3Check"
                  name="checkbox-3"
                  value="TRUE"
                  unchecked-value="FALSE"
                >
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row  v-if="this.dataToDisplay[0].Probe4Show == 'TRUE'">
              <b-col cols="3"> Probe 4 </b-col>
              <b-col cols="3"> {{ this.dataToDisplay[0].Probe4Feed }} </b-col>
              <b-col cols="4">
                {{ this.dataToDisplay[0].Probe4Position }}
              </b-col>
              <b-col cols="1">
                <b-form-checkbox
                  id="checkbox-4"
                  v-model="Probe4Check"
                  name="checkbox-4"
                  value="TRUE"
                  unchecked-value="FALSE"
                >
                </b-form-checkbox>
              </b-col>
            </b-row>
            <br/>
            <b-row>
              <b-col>
              <b-button variant="outline-success" v-on:click="submitProbeRemove()">
                Submit
              </b-button>
              </b-col>
              <b-col>
              <b-button variant="outline-info" v-on:click="cancelProbeRemove()">
                Cancel
              </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-modal>
        <b-modal id="ProbeToAdd" ref="ProbeToAdd" title="Select Probe to Add" hide-footer>
          <b-card>
            <template #header>
              Select Probe to Add to Device {{ getNewName(dataToDisplay[0].id,'O1') }}
            </template>
            <b-card v-if="this.dataToDisplay[0].Probe1Show=='TRUE' && this.dataToDisplay[0].Probe2Show=='TRUE' && this.dataToDisplay[0].Probe3Show=='TRUE'&&this.dataToDisplay[0].Probe4Show=='TRUE'">
              All Probes already active for this device
            </b-card>
            <b-card v-if="this.dataToDisplay[0].Probe1Show!='TRUE'||this.dataToDisplay[0].Probe2Show != 'TRUE'||this.dataToDisplay[0].Probe3Show != 'TRUE' || this.dataToDisplay[0].Probe4Show != 'TRUE'">
            <b-row>
              <b-col>Probe:</b-col>
              <b-col>
            <b-form-select v-model="ProbeNoToAdd">
              <b-form-select-option
                value="1"
                select
                v-if="this.dataToDisplay[0].Probe1Show != 'TRUE'"
                >Probe 1</b-form-select-option
              >
              <b-form-select-option
                value="2"
                select
                v-if="this.dataToDisplay[0].Probe2Show != 'TRUE'"
                >Probe 2</b-form-select-option
              >
              <b-form-select-option
                value="3"
                select
                v-if="this.dataToDisplay[0].Probe3Show != 'TRUE'"
                >Probe 3</b-form-select-option
              >
              <b-form-select-option
                value="4"
                select
                v-if="this.dataToDisplay[0].Probe4Show != 'TRUE'"
                >Probe 4</b-form-select-option
              >
            </b-form-select>
            </b-col>
            </b-row>
            <br/>
            <b-row><b-col>Probe Feed:</b-col></b-row>
            <b-row>
              <b-col>
            <b-form-select v-model="Feed" :options="feedArray">
                  </b-form-select>
                  </b-col>
                  </b-row>
                  <br/>
            <b-row><b-col>Probe Position:</b-col></b-row>
            <b-row>
            <b-col>
              <b-form-select v-model="Position" :options="positionArray"></b-form-select>
            </b-col></b-row>
            <br/>
            <b-row><b-col>Recirculatory:</b-col></b-row>
            <b-row>
            <b-col><b-form-select v-model="Recirc" :options="RecircOptions"></b-form-select></b-col></b-row>
            </b-card>
            <br/>
            <b-row>
              <b-col>
              <b-button variant="outline-success" v-on:click="submitProbeAdd()">
                Submit
              </b-button>
              </b-col>
              <b-col>
              <b-button variant="outline-info"  v-on:click="cancelProbeAdd()">
                Cancel
              </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-modal>
    <b-modal 
        size="xl"
        ref="DeviceActionsModal"
        id="DeviceActionsModal"
        title="Device Actions"
        content-class="Modal"
      >
      <b-card>
        <b-row><b-col><h5><b>Device: </b> {{ getNewName(dataToDisplay[0].id,"O1") }}</h5></b-col><b-col><h5><b>Install Date: </b>{{ dataToDisplay[0].InstallDate }}</h5></b-col></b-row>
        <b-row><b-col><h5><b>Room/Area: </b> {{ dataToDisplay[0].DeptFloor }}</h5></b-col><b-col><h5><b>Position Note: </b> {{ dataToDisplay[0].LocationNote }}</h5></b-col></b-row>
        </b-card>
      <b-card>
              <b-row>
                <b-col >
                  <b-button
                    variant="outline-success"
                    block
                    v-on:click="ProbesToAdd()"
                    >Add Probe</b-button
                  >
                </b-col>
                <b-col
                  ><b-button
                    variant="outline-danger"
                    block
                    v-on:click="ProbesToRemove()"
                    >Remove Probe</b-button
                  >
                </b-col>
                <!-- <b-col>
                  <b-button
                    variant="outline-danger"
                    block
                    v-on:click="
                      DeviceAction(dataToDisplay[0], 'SuspendToRelocate')
                    "
                    >Suspend to Relocate</b-button
                  >
                </b-col> -->
              </b-row>
              <b-row class="text-center">
                <b-col>
                 <p class="small">Add new probe to existing device</p> 
                </b-col>
                <b-col>
                 <p class="small"> Remove Probes from existing device</p>
                </b-col>
                <!-- <b-col>
                  <p class="small">Temporarily stop monitoring
                  (Can be reactivated)</p>
                </b-col>                 -->
              </b-row>
              <br />
            </b-card>
    </b-modal>
     <b-modal
            size="xl"
            header-bg-variant="light"
            header-text-variant="dark"
            ref="CalWizard"
            id="CalWizard"
            title="Device Calibrations"
            hide-footer>
            <b-card>
            <CALWizard @WizardComplete="FinishCALWizard" :Type="Type" :ID="ID"/>
            </b-card>

        </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import { IDToHuman } from "../../CustomFunctions/HumanName.js";
import CALWizard from "../CalibrationWizard/CALWizard.vue";

export default {
  props:['DataPass','Type','ID'],
  computed: {},
  components: {
    CALWizard
  },

  data() {
    return {
      dataToDisplay: [
        {
              id: "",
              Location: "",
              DeptFloor: "",
              LocationNote: "",
              CurrentTrend: "",
              NextServiceDate: "",
              NextServiceTime: "",
              NextServiceAction: "",
              LastServiceCheckDate: "",
              Probe1Show: "",
              Probe2Show: "",
              Probe3Show: "",
              Probe4Show: "",
              Probe1Feed: "",
              Probe1Position: "",
              Probe1LastTempMin: "",
              Probe1CalibrationDate: "",
              Probe1NextCalibrate: "",
              Probe1LastTempMax: "",
              Probe1LastTempAvg: "",

              Probe2Feed: "",
              Probe2Position: "",
              Probe2LastTempMin: "",
              Probe2CalibrationDate: "",
              Probe2NextCalibrate: "",
              Probe2LastTempMax: "",

              Probe2LastTempAvg: "",
              Probe3Feed: "",
              Probe3Position: "",
              Probe3LastTempMin: "",
              Probe3CalibrationDate: "",
              Probe3NextCalibrate: "",
              Probe3LastTempMax: "",

              Probe3LastTempAvg: "",

              Probe4Feed: "",
              Probe4Position: "",
              Probe4LastTempMin: "",
              Probe4CalibrationDate: "",
              Probe4NextCalibrate: "",
              Probe4LastTempMax: "",

              Probe4LastTempAvg: "",
              InstallDate: "",
              InstallTime: "",
              LastTempReadingDate: "",
              LastTempReadingTime: "",
              LinkedAssets: "",
              SubGroupCount: "",
        }
      ],
      UserURN: localStorage.getItem("UserURN"),
      UserProfile: localStorage.getItem("ProfilePortal"),
      clCompany: localStorage.getItem("Company"),
      nickname: localStorage.getItem("Nickname"),
      fields: [
        { key: "ID", variant: "primary" },
        { key: "Type" },
        { key: "DeptFloor" },
        { key: "PositionNote" },
        { key: "Status" },
        { key: "LocationGroups" },
        { key: "Action" },
      ],
      o1items: [],
      selectedlocation: localStorage.getItem("location"),
      Probe1Check: "",
      Probe2Check: "",
      Probe3Check: "",
      Probe4Check: "",
      ProbeNoToAdd: "",
      Feed: "",
      Position: "",
      Recirc: null,
      feedList: "",
      feedArray: [],
      positionlist: "",
      positionArray: [],
      RecircOptions: [{value: null, text: 'Please select an option'},{ value: 'TRUE', text: 'True' },
          { value: 'FALSE', text: 'False' }],
      DeviceIDToChange: { C1: [], O1: [] },
      IDsIhaveChanged: { C1: [], O1: [] },
      IDsToChange: { C1: [], O1: [] },
    };
  },

  beforeMount() {},

  mounted() {
    let LookUpUrl2 =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeaders2 = this.$apikeyPost;
    this.LookUpRequest = { RequestType: "PositionFeed" };
    axios
      .post(LookUpUrl2, this.LookUpRequest, LookUpHeaders2)
      .then((response) => {
        this.feedList = response.data.Feeds;
        this.positionList = response.data.Positions;
        for (let i = 0; i < this.feedList.length; i++) {
          var QuoteStr = this.feedList[i][0];
          this.feedArray.push({ text: this.feedList[i][1], value: QuoteStr });
        }
        for (let i = 0; i < this.positionList.length; i++) {
          var QuoteStr2 = this.positionList[i][0];
          this.positionArray.push({text: this.positionList[i][1],value: QuoteStr2})
        }
      });
    let LookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/locations";
    let LookUpHeaders = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "ClarenceDeviceLocation",
      LocationDict: [
        {
          Location: this.selectedlocation,
          FilterType: "",
          Feed: "",
          State: "",
        },
      ],
    };

    axios
      .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
      .then((response) => {

        let fulldataarray = response.data.Values

         for (let x=0;x<fulldataarray.length;x++){

          if(fulldataarray[x][6] == 'O-1'){
            this.IDGetArrays(fulldataarray[x][0], fulldataarray[x][6]);

            this.o1items.push({
              ID: fulldataarray[x][0],
              Type: fulldataarray[x][6],
              DeptFloor: fulldataarray[x][1],
              Position: "",
              PositionNote: fulldataarray[x][2],
              LocationGroups: fulldataarray[x][3],
              grouplist: fulldataarray[x][5],
              Status: fulldataarray[x][4],
            });
          }
        }

        this.SwitchToHuman("O1");

      });

  },

  methods: {
    async SwitchToHuman(Type) {
      if (Type == "O1") {
        let Names = await IDToHuman(this.IDsToChange.O1, Type);

        for (let q = 0; q < Names.length; q++) {
          this.IDsIhaveChanged.O1.push(this.IDsToChange[q]);
          this.DeviceIDToChange.O1.push({
            ID: this.IDsToChange.O1[q],
            Name: Names[q],
          });
        }
      }

      if (Type == "C1") {
        let Names = await IDToHuman(this.IDsToChange.C1, Type);

        for (let q = 0; q < Names.length; q++) {
          this.IDsIhaveChanged.C1.push(this.IDsToChange[q]);
          this.DeviceIDToChange.C1.push({
            ID: this.IDsToChange.C1[q],
            Name: Names[q],
          });
        }
      }
    },
    getNewName(data, Type) {
      let ClarenceType = Type;

      if (ClarenceType == "O1") {
        for (let i = 0; i < this.DeviceIDToChange.O1.length; i++) {
          if (data == this.DeviceIDToChange.O1[i].ID) {
            return this.DeviceIDToChange.O1[i].Name;
          }
        }
      } else {
        for (let i = 0; i < this.DeviceIDToChange.C1.length; i++) {
          if (data == this.DeviceIDToChange.C1[i].ID) {
            return this.DeviceIDToChange.C1[i].Name;
          }
        }
      }
      return data;
    },

    async IDGetArrays(ID, Type) {
      Type = Type.replace("-", "");
      if (Type == "C1") {
        if (
          this.IDsIhaveChanged.C1.includes(ID) ||
          this.IDsToChange.C1.includes(ID)
        ) {
          return;
        } else if (
          this.IDsIhaveChanged.C1.includes(ID) == false &&
          this.IDsToChange.C1.includes(ID) == false
        ) {
          this.IDsToChange.C1.push(ID);
        }
      }
      if (Type == "O1") {
        if (
          this.IDsIhaveChanged.O1.includes(ID) ||
          this.IDsToChange.O1.includes(ID)
        ) {
          return;
        } else if (
          this.IDsIhaveChanged.O1.includes(ID) == false &&
          this.IDsToChange.O1.includes(ID) == false
        ) {
          this.IDsToChange.O1.push(ID);
        }
      }
    },
    reset() {
      (this.Probe1Check = ""),
        (this.Probe2Check = ""),
        (this.Probe3Check = ""),
        (this.Probe4Check = ""),
        (this.ProbeNoToAdd = ""),
        (this.calibrationTime = ""),
        (this.calibrationDate = ""),
        (this.Feed = ""),
        (this.calibTemperature = ""),
        (this.flowCheckBox = "FALSE"),
        (this.recircCheckBox = "FALSE");
    },

    refreshTable() {
      this.feedList = "";
      this.feedArray = [];
      this.o1items = [];
      this.dataToDisplay = [];
      let LookUpUrl2 =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/lookup";
      let LookUpHeaders2 = this.$apikeyPost;
      this.LookUpRequest = { RequestType: "PositionFeed" };
      axios
        .post(LookUpUrl2, this.LookUpRequest, LookUpHeaders2)
        .then((response) => {
          this.feedList = response.data.Feeds;
          for (let i = 0; i < this.feedList.length; i++) {
            var QuoteStr = this.feedList[i][0];
            this.feedArray.push({ id: QuoteStr, value: this.feedList[i][1] });
          }
        });

      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/locations";
      let LookUpHeaders = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "ClarenceDeviceLocation",
        LocationDict: [
          {
            Location: this.selectedlocation,
            FilterType: "",
            Feed: "",
            State: "",
          },
        ],
      };

      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          let fulldataarray = response.data.Values

         for (let x=0;x<fulldataarray.length;x++){

          if(fulldataarray[x][6] == 'O-1'){
            this.IDGetArrays(fulldataarray[x][0], fulldataarray[x][6]);

            this.o1items.push({
              ID: fulldataarray[x][0],
              Type: fulldataarray[x][6],
              DeptFloor: fulldataarray[x][1],
              Position: "",
              PositionNote: fulldataarray[x][2],
              LocationGroups: fulldataarray[x][3],
              grouplist: fulldataarray[x][5],
              Status: fulldataarray[x][4],
            });
          }
        }

        this.SwitchToHuman("O1");

      });
    },
    DeviceAction(Data, Action) {
      let ActionType = "";
      if (Action == "SuspendToRelocate") {
        ActionType = "Suspend To Relocate";
      }

      if (
        confirm("Confirm if you want to " + ActionType + " " + Data.id) == true
      ) {
        if (Action == "SuspendToRelocate") {
          let LookUpUrl =
            "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
            this.$environment +
            "/device";
          let LookUpHeaders = this.$apikeyPost;
          this.LookUpRequest = {
            RequestType: "O1Deactivate",
            DeviceDict: [{ DeviceID: Data.id }],
          };

          axios
            .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
            .then((response) => {
              response;
              alert("Device Suspended for Relocation");
              // this.HistorySubmit("Suspended Device " + Data.id);
              this.refreshTable();
            });
        }
      }
    },
    submitProbeAdd() {
      if(this.ProbeNoToAdd == "" || this.Feed == "" || this.Position == "" || this.Recirc == null){
        alert("Please complete all fields for all probes")
      } else{
        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/device";
        let LookUpHeadersFeed = this.$apikeyPost;
      this.LookUpRequest = {
          RequestType: "AddO1Probe",
          DeviceDict: [
            {
              DeviceID: this.dataToDisplay[0].id,
              ProbeNumber: this.ProbeNoToAdd,
              ProbeFeed: this.Feed.toString(),
              Position: this.Position.toString(),
              User: this.$UserURN,
              Recirculatory: this.Recirc,
            },
          ],
        };
 
        axios
          .post(LookUpUrl, this.LookUpRequest, LookUpHeadersFeed)
          .then((response) => {
            response;
              this.$refs["ProbeToAdd"].hide();
              this.showCALWizard(this.dataToDisplay[0].id,"O1")
          });
        }
    },

    submitProbeRemove() {
      if (
        this.Probe1Check == "TRUE" ||
        this.Probe2Check == "TRUE" ||
        this.Probe3Check == "TRUE" ||
        this.Probe4Check == "TRUE"
      ) {
        let ProbeNos = [];

        if (this.Probe1Check == "TRUE") {
          ProbeNos.push("1");
        }
        if (this.Probe2Check == "TRUE") {
          ProbeNos.push("2");
        }
        if (this.Probe3Check == "TRUE") {
          ProbeNos.push("3");
        }
        if (this.Probe4Check == "TRUE") {
          ProbeNos.push("4");
        }
        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/device";
        let LookUpHeadersFeed = this.$apikeyPost;
        this.LookUpRequest = {
          RequestType: "RemoveO1Probe",
          DeviceDict: [
            {
              DeviceID: this.dataToDisplay[0].id,
              ProbeNumber: ProbeNos,
            },
          ],
        };
        axios
          .post(LookUpUrl, this.LookUpRequest, LookUpHeadersFeed)
          .then((response) => {
            response;
            this.reset();
            alert("Probe Removal submitted")
            this.$refs["ProbeToRemoveModal"].hide();
          });
      } else {
        alert("Please ensure you select at least one probe to remove");
      }
    },

    ProbesToAdd() {
      this.$refs["ProbeToAdd"].show();
    },
    ProbesToRemove() {
      this.$refs["ProbeToRemoveModal"].show();
    },
    getDataToAction(Data) {
      this.dataToDisplay = [];
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/dashboard";
      let LookUpHeadersFeed = this.$apikeyPost;
      this.LookUpRequest = {
        RequestVariable: Data.ID,
        Report: "O1DeviceDetail",
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeadersFeed)
        .then((response) => {
          let deviceData = response.data.Values;
          for (let i = 0; i < deviceData.length; i++) {
            let LinkedAssetsEndpointsArray = deviceData[i][33];
            let LinkedAssetsEndpointsData = [];

            for (let u = 0; u < LinkedAssetsEndpointsArray.length; u++) {
              LinkedAssetsEndpointsData.push({
                ID: LinkedAssetsEndpointsArray[u][0],
                Type: LinkedAssetsEndpointsArray[u][1],
              });
            }

            let Pipe1Calibration = "";
            let Pipe2Calibration = "";
            let Pipe3Calibration = "";
            let Pipe4Calibration = "";
            let NextPipe1Calibration = "";
            let NextPipe2Calibration = "";
            let NextPipe3Calibration = "";
            let NextPipe4Calibration = "";

            let LastServiceInfo = "";
            let NextServiceDue = "";
            // let LinkedAssetsInfo = "";

            if (deviceData[i][13] == null) {
              Pipe1Calibration = "No Previous Calibration";
              NextPipe1Calibration = "N/A";
            } else {
              Pipe1Calibration = deviceData[i][13];

              NextPipe1Calibration = new Date(Pipe1Calibration);
              let thisYear = NextPipe1Calibration.getFullYear();
              let nextYear = thisYear + 1;

              NextPipe1Calibration.setYear(nextYear);
              NextPipe1Calibration = NextPipe1Calibration.toISOString().slice(
                0,
                10
              );
            }
            if (deviceData[i][18] == null) {
              Pipe2Calibration = "No Previous Calibration";
              NextPipe2Calibration = "N/A";
            } else {
              Pipe2Calibration = deviceData[i][18];
              NextPipe2Calibration = new Date(Pipe2Calibration);
              let thisYear = NextPipe2Calibration.getFullYear();
              let nextYear = thisYear + 1;

              NextPipe2Calibration.setYear(nextYear);
              NextPipe2Calibration = NextPipe2Calibration.toISOString().slice(
                0,
                10
              );
            }
            if (deviceData[i][23] == null) {
              Pipe3Calibration = "No Previous Calibration";
              NextPipe3Calibration = "N/A";
            } else {
              Pipe3Calibration = deviceData[i][23];
              NextPipe3Calibration = new Date(Pipe3Calibration);
              let thisYear = NextPipe3Calibration.getFullYear();
              let nextYear = thisYear + 1;

              NextPipe3Calibration.setYear(nextYear);
              NextPipe3Calibration = NextPipe3Calibration.toISOString().slice(
                0,
                10
              );
            }
            if (deviceData[i][28] == null) {
              Pipe4Calibration = "No Previous Calibration";
              NextPipe4Calibration = "N/A";
            } else {
              Pipe4Calibration = deviceData[i][28];
              NextPipe4Calibration = new Date(Pipe4Calibration);
              let thisYear = NextPipe4Calibration.getFullYear();
              let nextYear = thisYear + 1;

              NextPipe4Calibration.setYear(nextYear);
              NextPipe4Calibration = NextPipe4Calibration.toISOString().slice(
                0,
                10
              );
            }

            if (deviceData[i][8] == null) {
              LastServiceInfo = "No Previous Service";
            } else {
              LastServiceInfo = deviceData[i][8];
            }

            if (
              deviceData[i][5] == null ||
              deviceData[i][6] == null ||
              deviceData[i][7] == null
            ) {
              NextServiceDue = "No Future Service Planned";
            } else {
              NextServiceDue = deviceData[i][5];
            }

            this.dataToDisplay.push({
              id: deviceData[i][0],
              Location: deviceData[i][1],
              DeptFloor: deviceData[i][2],
              LocationNote: deviceData[i][3],
              CurrentTrend: deviceData[i][4],
              NextServiceDate: NextServiceDue,
              NextServiceTime: deviceData[i][6],
              NextServiceAction: deviceData[i][7],
              LastServiceCheckDate: LastServiceInfo,
              Probe1Show: deviceData[i][9],
              Probe2Show: deviceData[i][14],
              Probe3Show: deviceData[i][19],
              Probe4Show: deviceData[i][24],
              Probe1Feed: deviceData[i][10],
              Probe1Position: deviceData[i][11],
              Probe1LastTempMin: deviceData[i][12],
              Probe1CalibrationDate: Pipe1Calibration,
              Probe1NextCalibrate: NextPipe1Calibration,
              Probe1LastTempMax: deviceData[i][35],
              Probe1LastTempAvg: deviceData[i][36],

              Probe2Feed: deviceData[i][15],
              Probe2Position: deviceData[i][16],
              Probe2LastTempMin: deviceData[i][17],
              Probe2CalibrationDate: Pipe2Calibration,
              Probe2NextCalibrate: NextPipe2Calibration,
              Probe2LastTempMax: deviceData[i][37],

              Probe2LastTempAvg: deviceData[i][38],
              Probe3Feed: deviceData[i][20],
              Probe3Position: deviceData[i][21],
              Probe3LastTempMin: deviceData[i][22],
              Probe3CalibrationDate: Pipe3Calibration,
              Probe3NextCalibrate: NextPipe3Calibration,
              Probe3LastTempMax: deviceData[i][39],

              Probe3LastTempAvg: deviceData[i][40],

              Probe4Feed: deviceData[i][25],
              Probe4Position: deviceData[i][26],
              Probe4LastTempMin: deviceData[i][27],
              Probe4CalibrationDate: Pipe4Calibration,
              Probe4NextCalibrate: NextPipe4Calibration,
              Probe4LastTempMax: deviceData[i][41],

              Probe4LastTempAvg: deviceData[i][42],
              InstallDate: deviceData[i][29],
              InstallTime: deviceData[i][30],
              LastTempReadingDate: deviceData[i][31],
              LastTempReadingTime: deviceData[i][32],
              LinkedAssets: LinkedAssetsEndpointsData,
              SubGroupCount: deviceData[i][34],
            });
          }
          this.loading = false;
          this.$refs['DeviceActionsModal'].show()
        });
    },
    showCALWizard(id,devicetype){
          this.ID = id,
          this.Type = devicetype,
          this.$refs["CalWizard"].show();
        },
    FinishCALWizard(){
            this.$refs["CalWizard"].hide();
        },
    cancelProbeAdd(){
        this.ProbeNoToAdd = "",
        this.Feed = "",
        this.Position = "",
        this.Recirc = null,
        this.$refs["ProbeToAdd"].hide();
        },
    cancelProbeRemove(){
        this.Probe1Check = "",
        this.Probe2Check = "",
        this.Probe3Check = "",
        this.Probe4Check = "",
        this.$refs["ProbeToRemoveModal"].hide();
        }
  },
  watch: {},
};
</script>

<style scoped>



</style>
